import { Column, TablePaginated, TablePaginatedOptions } from '@acceso/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RenderActionButtons } from '@/components/RenderActionButtons';
import { TableRow } from '@/components/TableRow';
import { TableUpdatedBy } from '@/components/TableUpdatedBy';

import { useSupportsFilters } from '../../stores/supports-filters';
import { TSupport } from '../../types';

interface SupportsTableProps {
  items: TSupport[];
  totalItems: number;
  isFetching?: boolean;
  onUpdate?: (support: TSupport) => void;
  onDelete?: (support: TSupport) => void;
}

export function SupportsTable({
  items,
  totalItems,
  isFetching,
  onUpdate,
  onDelete,
}: SupportsTableProps) {
  const { t } = useTranslation();
  const { setPage, setRows, paginationValues } = useSupportsFilters();

  const options: Partial<TablePaginatedOptions> = {
    pagination: {
      changePage: setPage,
      changeRows: setRows,
      currentPage: paginationValues.currentPage,
      itemsPerPage: paginationValues.rowsPerPage,
    },
  };

  const columns: Column<TSupport>[] = useMemo(
    (): Column<TSupport>[] => [
      {
        id: 'name',
        title: t('Nombre'),
        render: item => {
          return <TableRow showTooltip content={item.alias[0] || ''} />;
        },
      },
      {
        id: 'updated_by',
        title: t('Actualizado por'),
        render: item => {
          return <TableUpdatedBy item={item} />;
        },
      },
      {
        id: 'system',
        title: t('Origen'),
        render: item => {
          return <TableRow showTooltip content={item.is_system ? t('Sistema') : t('Usuario')} />;
        },
      },
      {
        id: 'actions',
        title: '',
        className: 'items-end',
        width: '5%',
        render: item =>
          !item.is_system ? (
            <RenderActionButtons
              item={item}
              onUpdate={() => onUpdate?.(item)}
              onDelete={() => onDelete?.(item)}
            />
          ) : null,
      },
    ],
    [t, onUpdate, onDelete]
  );

  return (
    <TablePaginated
      data={items}
      totalItems={totalItems}
      options={options}
      columns={columns}
      isFetching={isFetching}
      ignoreEmpty
    />
  );
}
